import CrudBase from '../../../CrudBase';
import axios from '../../../../axios-common';

class WalletApi extends CrudBase {
	getWallet = (params) => axios.get(`${this.endpoint}/get-by`, params);

	defaultMethods = {
		getWallet: this.getWallet,
	};
}

const acompanhamento = new WalletApi('api/v1/wallet');

export default acompanhamento.defaultMethods;
